import React, { Component } from 'react';
import CorporateTools from '../components/corporateTools';

import performanceAnalysis from '../resources/images/estrategas/tools/performanceAnalysis.png';
import checkOperative from '../resources/images/estrategas/tools/operativeCheck.png';
import strategyImage from '../resources/images/estrategas/tools/strategy.png';
import blank from '../resources/images/estrategas/tools/blank.png';

class ActionTools extends Component {
  actionToolsLoop() {
    return (
      <div className={'container-fluid'}>
        <div className={'row'}>
          <div className={'col-md-6 pl-0'}>
            <div className={'container-fluid m-2'}>
              <div className={'title-places'}>
                Corporativo Estrategas
              </div>
              <CorporateTools/>
            </div>
          </div>
          <div className={'col-md-6 pl-0'}>
            <div className={'container-fluid m-2'}>
              <div className={'title-places'}>
                Operaciones Estrategas
              </div>
              <div className={'row'}>
                <div className="col-md-4 col-3">
                  <a href={this.props.kpis.kpi} target='_blank'>
                    <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
                      <img src={performanceAnalysis} alt=" " className="imgStyle"/>
                      <h5>Análisis de Desempeño</h5>
                    </div>
                  </a>
                </div>
                <div className="col-md-4 col-3">
                  <a href={this.props.kpis.kpiMonitor} target='_blank'>
                    <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
                      <img src={checkOperative} alt=" " className="imgStyle"/>
                      <h5>Monitoreo Operativo</h5>
                    </div>
                  </a>
                </div>
                <div className="col-md-4 col-3">
                  <a href={this.props.kpis.kpiStrategy} target='_blank'>
                    <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
                      <img src={strategyImage} alt=" " className="imgStyle"/>
                      <h5>Estrategia</h5>
                    </div>
                  </a>
                </div>
                <div className="col-md-4 col-3">
                  <div className="product-single tool pl-0 pr-0" style={{
                    boxShadow: 'none',
                    cursor: 'auto'
                  }}>
                    <img src={blank} alt=" " className="imgStyle" style={{ borderStyle: 'none' }}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="readmin-products">
        {this.actionToolsLoop()}
      </div>
    );
  }
}

export default ActionTools;



// WEBPACK FOOTER //
// ./src/containers/actionTools.js